<template>
    <div class="pro-content flex flex-v flex-1">
        <div class="title">
            <el-row>
                <el-col :span="3" class="first">单号</el-col>
                <el-col :span="6">名称</el-col>
                <el-col :span="4">单价</el-col>
                <el-col :span="3">数量</el-col>
                <el-col :span="5">权益</el-col>
                <el-col :span="3">折后价</el-col>
            </el-row>
        </div>
        <div class="content" ref="pro_content">
            <div v-for="(data, key) in listData" :key="key">
                <el-row class="line" v-for="(item, i) in data.pro_list" :key="i">
                    <el-col :span="3" class="first">
                        {{data.order_no ? data.order_no : "无"}}
                    </el-col>
                    <el-col :span="6">
                        <div class="pro-name">
                            {{item.pro_name === 'null' ? "&nbsp;" : item.pro_name}}
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <cash-text-input v-model="item.price" @change="resetTotalPrice(item)" />
                    </el-col>
                    <el-col :span="3">
                        <cash-text-input v-model="item.num" @change="resetTotalPrice(item)" />
                    </el-col>
                    <el-col :span="5">
                        <cash-discount-select :item-data="item" :dis-model="discountModel" @discountChange="dk => {discountChange(item, dk);}" />
                    </el-col>
                    <el-col :span="3">
                        <cash-text-input v-model="item.total_price" @change="updateProductList" />
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import TextInput from "@/model/TextInput";
    import CashTextInput from "@/model/Cash/CashTextInput";
    import CashDiscountSelect from "@/model/Cash/CashDiscountSelect";
    export default {
        name: "CashTotalProduct",
        components: {CashDiscountSelect, CashTextInput, TextInput},
        props: {
            content: {
                type: Array,
                default: []
            },
            userInfo: {
                type: Object,
                default: () => ({})
            },
            disModel: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => {
            return {
                listData: [],
                discountModel: null
            };
        },
        mounted: function () {
            this.initData(true);
        },
        methods: {
            //初始化
            initData: function (t) {
                // obj.log(this.disModel);
                this.discountModel = this.disModel;
                this.listData = this.content;
                if(t) {
                    obj.unScrollbar(".pro-content>.content");
                    this.$nextTick(() => {
                        obj.scrollbar(".pro-content>.content");
                    });
                }else{
                    obj.updateScrollbar(".pro-content>.content");
                }
            },
            //更新项目列表数据
            updateProductList: function () {
                this.$emit("updateProductList", this.listData);
            },
            //更改优惠
            discountChange: function (item, typeVal) {
                // this.resetTotalPrice(item);
                this.$emit("discountChange", {
                    item: item,
                    discountIndex: typeVal
                });
            },
            //重新计算价格
            resetTotalPrice: function (item) {
                this.$emit("resetTotalPrice", item);
            },
        },
        watch: {
            content: function () {
                this.initData(false);
            },
            disModel: function (newModel) {
                this.discountModel = newModel;
            }
        }
    }
</script>

<style scoped>
    .pro-content .title {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        text-align: center;
        border-bottom: 1px solid #ebedf0;
        font-size: 14px;
        font-weight: bold;
        color: #909399;
        background-color: #f4f4f4;
    }
    .pro-content .content {
        overflow: auto;
        text-align: center;
        padding-bottom: 16px;
        flex: 1;
    }
    .pro-content .content .line {
        line-height: 40px;
        /*padding: 5px 0;*/
        border-bottom: 1px solid #ebedf0;
        overflow:hidden;
    }
    .pro-content .content .line>.el-col>*{
        display: inline-block;
        vertical-align: middle;
    }
    .pro-content .content .line:hover{
        background-color: #F5F7FA;
    }
    .select_staff{
        border: none;
    }
    .first{
        padding-left: 30px;
        text-align: left;
    }
    .pro-name{
        line-height: 22px;
        padding: 11px 0px;
    }
    .pro_price{
        text-align: center;
        border: none;
        background: transparent;
        padding: 4px 0px;
        width: 90%;
    }
    .pro_price:hover, .pro_price.cur{
        border: 1px solid #dddddd;
        background: #FFFFFF;
    }
    .opt-h,.opt-c{
        display: block !important;
        text-align: right;
        margin-right: 10px;
    }
    .opt-h{
        padding-right: 15px;
    }
</style>
